import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  style: {"color":"rgba(0, 0, 0, 0.87)","font-size":"14px"},
  class: "pl-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oss_dialog, {
      onKeydown: _cache[18] || (_cache[18] = _withKeys(($event: any) => (_ctx.dialog = false), ["esc"])),
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dialog) = $event)),
      title: _ctx.accountableAccountEdition.name ? 'Éditer' : 'Créer',
      width: "800px"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn_primary, {
          rounded: "",
          block: "",
          onClick: _ctx.onValidateClick,
          disabled: !_ctx.validAccount,
          size: "x-large"
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [
            _createTextVNode("Valider")
          ])),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "default_card large mx-0 pa-2",
          elevation: "0",
          style: {"width":"600px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: _ctx.validAccount,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.validAccount) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "4",
                      style: {"overflow-y":"auto"}
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.accountableAccountEdition.id)
                          ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                              key: 0,
                              modelValue: _ctx.accountableAccountEdition.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountableAccountEdition.name) = $event)),
                              class: "px-1 py-1",
                              autofocus: "",
                              label: "Numéro de compte",
                              "hide-details": 'auto',
                              "data-cy": _ctx.cypressPrefixKey + 'accountableAccountEdition-name',
                              rules: [_ctx.rules.aaLength, _ctx.rules.checkExists, _ctx.rules.isAA],
                              disabled: _ctx.accountableAccountEdition.disabled
                            }, null, 8, ["modelValue", "data-cy", "rules", "disabled"]))
                          : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                              key: 1,
                              "model-value": _ctx.accountableAccountEdition.name,
                              class: "px-1 py-1",
                              autofocus: "",
                              label: "Numéro de compte",
                              disabled: "",
                              "data-cy": _ctx.cypressPrefixKey + 'accountableAccountEdition-name'
                            }, null, 8, ["model-value", "data-cy"]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "8",
                      style: {"overflow-y":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.accountableAccountEdition.description,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accountableAccountEdition.description) = $event)),
                          label: "Description",
                          "hide-details": "",
                          class: "px-1 py-1",
                          rules: [(v) => v !== ''],
                          readonly: _ctx.accountableAccountEdition.disabled,
                          density: "compact"
                        }, null, 8, ["modelValue", "rules", "readonly"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "d-flex mt-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_input, {
                          modelValue: _ctx.accountableAccountEdition.thirdParty,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.accountableAccountEdition.thirdParty) = $event)),
                          rules: [_ctx.rules.thirdParty],
                          "hide-details": "auto",
                          class: "centered-input"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_chip_group, {
                              modelValue: _ctx.accountableAccountEdition.thirdParty,
                              "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountableAccountEdition.thirdParty) = $event)),
                                _cache[3] || (_cache[3] = ($event: any) => (
                                            _ctx.accountableAccountEdition.onThirdPartyChanged()
                                        ))
                              ],
                              disabled: _ctx.thirdPartyReadOnly || _ctx.is6Account(_ctx.accountableAccountEdition.name),
                              style: _normalizeStyle(_ctx.is6Account(_ctx.accountableAccountEdition.name) ? 'opacity: 0.4' : '')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdParties, (option) => {
                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                    key: option.value,
                                    variant: "text",
                                    color: "white",
                                    disabled: _ctx.accountableAccountEdition.disabled,
                                    value: option.value,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      (
                                                        _ctx.accountableAccountEdition.thirdParty !==
                                                        option.value
                                                    )
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            color: "secondary",
                                            size: "small",
                                            icon: "$oss-circle-uncheck"
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 1,
                                            color: "secondary",
                                            size: "small",
                                            icon: "$oss-circle-check"
                                          })),
                                      _createElementVNode("span", _hoisted_1, _toDisplayString(option.text), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "style"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "d-flex pt-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          density: "compact",
                          modelValue: _ctx.accountableAccountEdition.lettering,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.accountableAccountEdition.lettering) = $event)),
                          label: "À lettrer",
                          "hide-details": "",
                          disabled: _ctx.is6Account(_ctx.accountableAccountEdition.name),
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.letteringHasChangedCount += 1)),
                          class: "pr-2"
                        }, null, 8, ["modelValue", "disabled"]),
                        (!_ctx.is6or7Account(_ctx.accountableAccountEdition.name))
                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: 0,
                              disabled: _ctx.accountableAccountEdition.lettering || _ctx.is6Account(_ctx.accountableAccountEdition.name),
                              density: "compact",
                              modelValue: _ctx.accountableAccountEdition.detailedCarryForward,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accountableAccountEdition.detailedCarryForward) = $event)),
                              label: "À-nouveaux détaillés",
                              "hide-details": "",
                              class: "pl-2"
                            }, null, 8, ["disabled", "modelValue"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.enableAccountPublish)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "d-flex pt-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "d-flex justify-center align-center",
                          style: {"overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              density: "compact",
                              modelValue: _ctx.accountableAccountEdition.publish,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.accountableAccountEdition.publish) = $event)),
                              label: "Publier au client",
                              "hide-details": "",
                              class: "pr-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "8",
                          style: {"overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.accountableAccountEdition.shortDescription,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.accountableAccountEdition.shortDescription) = $event)),
                              label: "Description proposée au client",
                              "hide-details": "",
                              class: "px-1 py-1",
                              rules: _ctx.accountableAccountEdition.publish ? [(v) => v !== ''] : [],
                              density: "compact"
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isVatOrSalesAccount)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": "",
                      class: "d-flex pt-6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-center align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => {
                                    _ctx.accountableAccountEdition.vatRate = null;
                                    _ctx.accountableAccountEdition.vatType = null;
                                    _ctx.accountableAccountEdition.vatOperationType = null;
                                }, ["stop"])),
                              class: "mr-3",
                              size: "small",
                              icon: "$oss-close"
                            }),
                            _createVNode(_component_v_select_filled, {
                              cols: _ctx.isVatAccount ? 4 : 6,
                              modelValue: _ctx.accountableAccountEdition.vatRate,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.accountableAccountEdition.vatRate) = $event)),
                              items: _ctx.vatRates,
                              "item-title": "text",
                              "item-value": "value",
                              required: "",
                              density: "compact",
                              label: "Taux de TVA",
                              "hide-details": "auto",
                              class: "px-1 py-1",
                              disabled: !!_ctx.accountableAccountEdition.vatType
                            }, null, 8, ["cols", "modelValue", "items", "disabled"]),
                            (_ctx.accountableAccountEdition.vatRate === 0)
                              ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                  key: 0,
                                  cols: _ctx.isVatAccount ? 4 : 6,
                                  modelValue: _ctx.accountableAccountEdition.vatType,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.accountableAccountEdition.vatType) = $event)),
                                  items: _ctx.vatTypes,
                                  "item-title": "text",
                                  "item-value": "value",
                                  required: "",
                                  density: "compact",
                                  label: "Type de TVA",
                                  "hide-details": "auto",
                                  class: "px-1 py-1"
                                }, null, 8, ["cols", "modelValue", "items"]))
                              : _createCommentVNode("", true),
                            (_ctx.isVatAccount)
                              ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                  key: 1,
                                  cols: "4",
                                  modelValue: _ctx.accountableAccountEdition.vatOperationType,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.accountableAccountEdition.vatOperationType) = $event)),
                                  items: _ctx.vatOperationTypes,
                                  "item-title": "text",
                                  "item-value": "value",
                                  required: "",
                                  density: "compact",
                                  label: "Type d'opération",
                                  "hide-details": "auto",
                                  class: "px-1 py-1"
                                }, null, 8, ["modelValue", "items"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isZtillReceipt)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex py-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_divider),
                          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-regular pt-2 px-3" }, "Affectation automatique", -1))
                        ]),
                        _: 1
                      }),
                      (_ctx.isZtillReceipt)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": "",
                            class: "d-flex"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: _ctx.isFiveAccount ? 6 : 9,
                                class: "d-flex justify-center align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select_filled, {
                                    modelValue: _ctx.accountableAccountEdition.transactionType,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.accountableAccountEdition.transactionType) = $event)),
                                    items: _ctx.transactionTypes,
                                    "item-title": "text",
                                    "item-value": "value",
                                    density: "compact",
                                    label: "Transaction bancaire",
                                    "hide-details": "auto",
                                    class: "px-1 py-1",
                                    disabled: 
                                        _ctx.isDefaulted || !!_ctx.accountableAccountEdition.paidAndUncashed
                                    
                                  }, null, 8, ["modelValue", "items", "disabled"])
                                ]),
                                _: 1
                              }, 8, ["cols"]),
                              (_ctx.isFiveAccount)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "3",
                                    class: "d-flex justify-center align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox_btn, {
                                        modelValue: _ctx.accountableAccountEdition.paidAndUncashed,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.accountableAccountEdition.paidAndUncashed) = $event)),
                                        label: "Payé et non encaissé",
                                        color: "primary",
                                        disabled: 
                                        _ctx.isDefaulted || !!_ctx.accountableAccountEdition.transactionType
                                    ,
                                        ripple: false
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_col, {
                                cols: "3",
                                class: "d-flex justify-center align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_switch, {
                                    "hide-details": "auto",
                                    modelValue: _ctx.accountableAccountEdition.default,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.accountableAccountEdition.default) = $event)),
                                    label: "Par défaut",
                                    class: "d-flex px-1",
                                    disabled: 
                                        _ctx.isDefaulted ||
                                        !(
                                            _ctx.accountableAccountEdition.transactionType ||
                                            _ctx.accountableAccountEdition.paidAndUncashed
                                        )
                                    
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    (_ctx.confirmationDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          onClose: _ctx.cancelDeleteLetteringsChoice,
          modelValue: _ctx.confirmationDialog,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.confirmationDialog) = $event)),
          title: "Confirmation",
          width: "800px"
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn_primary, {
              rounded: "",
              block: "",
              onClick: _ctx.confirmDeleteLetteringsChoice,
              size: "x-large"
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("Confirmer")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  style: {"overflow-y":"auto"}
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createElementVNode("div", {
                      dense: "",
                      outlined: "",
                      class: "px-1 py-1 oss-"
                    }, " Si vous décochez la case \"À-lettrer\", les lettrages des exercices non clos seront supprimés de manière irréversible. ", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClose", "modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.propagationDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 1,
          onClose: _ctx.cancelPropagation,
          modelValue: _ctx.propagationDialog,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.propagationDialog) = $event)),
          title: "Souhaitez-vous propager les modifications ?",
          validTitle: "Confirmer",
          onValid: _ctx.confirmPropagation,
          width: "800px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              dense: "",
              "hide-details": "",
              class: "mx-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "d-flex justify-center align-center" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propagation, (item) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: item.title
                      }, [
                        (item.show)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              title: item.title
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_list_item_action, { start: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_checkbox_btn, {
                                      color: "primary",
                                      modelValue: item.active,
                                      "onUpdate:modelValue": ($event: any) => ((item.active) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["title"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClose", "modelValue", "onValid"]))
      : _createCommentVNode("", true)
  ]))
}